"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicForm = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const index_1 = require("../index");
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const disable_focus_wrapper_1 = require("../disable-focus-wrapper");
const form_fields_1 = require("./form-fields");
const legal_disclaimer_1 = require("./legal-disclaimer");
const StyledSubmitButton = components_core_1.styled.div `
  padding-top: 11px;
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    padding-top: 21px;
  }
`;
const StyleForm = components_core_1.styled.form `
  margin-bottom: 20px;
`;
const DynamicForm = ({ children, fields, config, modelDropdownOptions }) => {
    const { submitLabel, formName, legalDisclaimer } = config;
    const props = (0, formik_1.useFormikContext)();
    const { isSubmitting, handleSubmit, isValid } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(StyleForm, { onSubmit: handleSubmit, name: formName, className: "dynamic-form-wrapper" },
            react_1.default.createElement(components_core_1.Container, { gutter: {
                    [components_core_1.Breakpoints.default]: components_core_1.ContainerGutter.static500,
                    [components_core_1.Breakpoints.b960]: components_core_1.ContainerGutter.static510
                }, wrap: "always" },
                modelDropdownOptions &&
                    (0, form_fields_1.getSelectGroupElement)(fields.modelName, fields.trim, modelDropdownOptions, props),
                (0, form_fields_1.getInputTextElement)(fields.firstName, props),
                (0, form_fields_1.getInputTextElement)(fields.lastName, props),
                (0, form_fields_1.getInputTextElement)(fields.email, props, ![fields.email.name, 'either'].includes(props.values.preferredContactMethod)),
                (0, form_fields_1.getInputTextElement)(fields.phone, props, ![fields.phone.name, 'either'].includes(props.values.preferredContactMethod)),
                (0, form_fields_1.getRadioButtonGroupElement)(fields.preferredContactMethod, props),
                (0, form_fields_1.getTextAreaInput)(fields.comments, props),
                react_1.default.createElement(components_core_1.Container, null,
                    react_1.default.createElement(legal_disclaimer_1.LegalFormDisclaimer, { disclaimer: legalDisclaimer }))),
            react_1.default.createElement(StyledSubmitButton, { className: "submit-button-container" },
                react_1.default.createElement(components_core_1.Layout, { appearance: {
                        [components_core_1.Breakpoints.default]: [
                            { name: 'a', columns: 12 },
                            { name: '.', columns: 12 }
                        ],
                        [components_core_1.Breakpoints.b960]: [
                            { name: 'a', columns: 8 },
                            { name: '.', columns: 16 }
                        ]
                    } },
                    react_1.default.createElement(disable_focus_wrapper_1.DisableFocusWrapper, null,
                        react_1.default.createElement(index_1.Button, { appearance: index_1.ButtonAppearance.Primary, type: index_1.ButtonType.Submit, disabled: isSubmitting || !isValid, stretchContent: true },
                            react_1.default.createElement(components_core_1.Text, { color: components_core_1.TokenTextColor.inherit, appearance: components_core_1.TokenTextAppearance.copy100 }, submitLabel || 'Submit'))))))));
};
exports.DynamicForm = DynamicForm;
